module.exports = __webpack_public_path__ + "img/editor_icon.8a573844.svg";